/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { _initialState } from '../_initialState';

export default (set, get, flag) => {

  return set(produce(get(), (draft) => {
    if (flag) {
      draft.design.hasAccessories = flag;
    }
  }), false, { type: 'ADD_OUTSIDE' });
};
